module.exports = __webpack_public_path__ + "static/media/dustin.56ebb6b7.jpg";